import { ONE_HOUR_IN_SECONDS } from '@/lib/constants';

export const secondsToHours = (seconds: number): number => {
  return seconds / ONE_HOUR_IN_SECONDS;
};
